export type MapViewportTarget =
  | { mode: "none" }
  | { mode: "point"; center: [number, number]; zoom: number }
  | { mode: "bounds"; southwest: [number, number]; northeast: [number, number] };

/** Resolve how to frame [lng, lat] coords when fitBounds would collapse to a point. */
export function resolveMapViewportTarget(
  coords: readonly [number, number][],
  pointZoom = 16,
): MapViewportTarget {
  // One read of the head coordinate narrows it for every branch below, so a length check is no
  // longer the only thing standing between an empty array and an index access.
  const first = coords[0];
  if (first === undefined) {
    return { mode: "none" };
  }
  if (coords.length === 1) {
    return { mode: "point", center: first, zoom: pointZoom };
  }

  let minLng = first[0];
  let maxLng = first[0];
  let minLat = first[1];
  let maxLat = first[1];

  for (const [lng, lat] of coords.slice(1)) {
    minLng = Math.min(minLng, lng);
    maxLng = Math.max(maxLng, lng);
    minLat = Math.min(minLat, lat);
    maxLat = Math.max(maxLat, lat);
  }

  if (minLng === maxLng && minLat === maxLat) {
    return { mode: "point", center: [minLng, minLat], zoom: pointZoom };
  }

  return {
    mode: "bounds",
    southwest: [minLng, minLat],
    northeast: [maxLng, maxLat],
  };
}
